import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 15h-4v6h4v-6","key":"svg-0"}],["path",{"d":"M12 15v-4","key":"svg-1"}],["path",{"d":"M8 21h8","key":"svg-2"}],["path",{"d":"M19 3v8h-14v-8","key":"svg-3"}]]

/**
 * IconRugby
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcnVnYnkiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE0IDE1aC00djZoNHYtNiIgLz4KICA8cGF0aCBkPSJNMTIgMTV2LTQiIC8+CiAgPHBhdGggZD0iTTggMjFoOCIgLz4KICA8cGF0aCBkPSJNMTkgM3Y4aC0xNHYtOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/rugby
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconRugby = createReactComponent('outline', 'rugby', 'Rugby', __iconNode);

export default IconRugby;